import "./wizard.scss";

interface PropsWizard {
  names: string[];
  activeIndex: number;
}

export const Wizard = ({ names, activeIndex }: PropsWizard) => {
  const pathLogo = require("../../assets/images/icon-check.svg");
  return (
    <>
      <div className="flex">
        {names.map((val, index) => (
          <>
            {index < activeIndex ? (
              <img src={pathLogo.default} className="Iconcheck cercle" style={{backgroundColor:"#56a476"}}/>
            ) : (
              <div
                className="cercle"
                style={{
                  backgroundColor: activeIndex === index ? "#007eae" : "#fff",
                }}
              >
                <span
                  className="number"
                  style={{ color: activeIndex === index ? "#fff" : "" }}
                >
                  {index + 1}
                </span>
              </div>
            )}
            <div className="valeur">
            {activeIndex === index ?  <b className="text-lg">{val}</b> :  <span className="text-lg">{val}</span> }
            </div>
            {names.length-1 === index ? "" :  <div className="line"></div>}
          </>
        ))}
      </div>
    </>
  );
};
